export default {
  all: [],
  items: [],
  pagination: {
    currentPage: 1,
    lastPage: 0,
    limit: 10,
    totalCount: 0,
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/excisePeriod/state.js